import React from 'react';
import { AccordionContainer } from '../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../common/components/form/input/containers/input.container';

export default function GlobalDbnServiceCategoryBasicInfoComponent({
  domains,
  handleInnerFormChange, handleInnerChange,
  selectedCategory,
  parentCategory, childCategory, subselectedCategory
}: any) {
  const formatDateOnly = (dateValue: string) => {
    if (!dateValue) return "";

    return new Date(dateValue).toISOString().split("T")[0];
  };
  return (
    <>
      <AccordionContainer
        headerTitle="New Service Category Group"
        expandedPanel="userInfo"
        child={
          <div className="grid md:grid-cols-2 gap-4">

            {/* Group Code */}
            <InputContainer
              label="Group Code"
              name="Code"
              type="text"
              value={selectedCategory?.Code}
              isDisabled={!!selectedCategory?.GlobalDBNServiceCategoryGroupId}
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'Code'
                );
              }}
            />

            {/* Group Name */}
            <InputContainer
              label="Group Name"
              name="Name"
              type="text"
              value={selectedCategory?.Name}
              isDisabled={!!selectedCategory?.GlobalDBNServiceCategoryGroupId}
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'Name'
                );
              }}
            />

            <div className="md:col-span-2">
              <InputContainer
                label="Description"
                name="Description"
                type="text"
                value={selectedCategory?.Description}
                onValueChange={(event: any) => {
                  handleInnerFormChange(
                    event.target.value,
                    'Description'
                  );
                }}
              />
            </div>

            {/* L1 Domain */}
            <InputContainer
              isDisabled={selectedCategory?.GlobalDBNServiceCategoryGroupId}
              label="L1 Domain"
              labelField="Name"
              list={domains}
              type="select"
              optionName="Select Domain"
              value={selectedCategory?.GlobalDBNDomainId}
              valueField="GlobalDBNDomainId"
              onValueChange={(event: any) => {
                handleInnerFormChange(Number(event.target.value), 'GlobalDBNDomainId');
              }}
            />

            {/* L2 Category */}
            <InputContainer
             isDisabled={selectedCategory?.GlobalDBNServiceCategoryGroupId}
              label="L2 Category"
              labelField="Name"
              list={parentCategory}
              type="select"
              optionName="Select Category"
              // isDisabled={!selectedCategory?.GlobalDBNDomainId}
              value={selectedCategory?.GlobalDBNCategoryId}
              valueField="GlobalDBNCategoryId"
              onValueChange={(event: any) => {
                const selectedId = Number(event.target.value);

                const selectedItem = parentCategory?.find(
                  (item: any) => Number(item.GlobalDBNCategoryId) === selectedId
                );

                if (selectedItem) {
                  handleInnerFormChange(selectedItem.GlobalDBNCategoryId, 'ParentCategoryId');
                  handleInnerFormChange(selectedItem.GlobalDBNCategoryId, 'GlobalDBNCategoryId');
                }
              }}
            />
          
            <InputContainer
              isDisabled={!selectedCategory?.ParentCategoryId}
              label="L3 Category"
              labelField="Name"
              list={childCategory}
              onValueChange={(newValue: any) => {
                const valueData: any = newValue.map((option: any) => option?.value || '');
                handleInnerChange({
                  value: valueData,
                  field: 'GlobalDBNCategoryId'
                });
              }}
              type="multiselect"
              valueField="GlobalDBNCategoryId"
               value={
                (subselectedCategory || []).map(
                  (item: any) => Number(item?.GlobalDBNCategoryId)
                )
              }
              />

            {/* Effective From */}
            <InputContainer
              label="Effective From"
              name="EffectiveFrom"
              type="date"
              value={formatDateOnly(selectedCategory?.CreatedOnUtc)}
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'CreatedOnUtc'
                );
              }}
            />

            <InputContainer
              label="Effective To"
              name="EffectiveTo"
              type="date"
              value={formatDateOnly(selectedCategory?.ModifiedOnUtc)}
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'ModifiedOnUtc'
                );
              }}
            />
            <InputContainer
              label="Active"
              labelField="IsActive"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event,
                  'IsActive',

                );
              }}
              type="checkbox"
              value={selectedCategory?.IsActive}
            />

          </div >
        }
      />
    </>
  );
}